import { z } from "zod";
import {
  DTOCreateDocumentationPageInputV2,
  DTODeleteDocumentationPageInputV2,
  DTODocumentationPageApprovalStateChangeInput,
  DTODuplicateDocumentationPageInputV2,
  DTOMoveDocumentationPageInputV2,
  DTORestoreDocumentationGroupInput,
  DTORestoreDocumentationPageInput,
  DTOUpdateDocumentationPageDocumentInputV2,
  DTOUpdateDocumentationPageInputV2,
} from "./page-v2";

//
// Read
//

const SuccessPayload = z.object({
  success: z.literal(true),
});

export const DTODocumentationPageCreateActionOutputV2 = z.object({
  type: z.literal("DocumentationPageCreate"),
  output: SuccessPayload,
});

export const DTODocumentationPageUpdateActionOutputV2 = z.object({
  type: z.literal("DocumentationPageUpdate"),
  output: SuccessPayload,
});

export const DTODocumentationPageUpdateDocumentActionOutputV2 = z.object({
  type: z.literal("DocumentationPageUpdateDocument"),
  output: SuccessPayload,
});

export const DTODocumentationPageMoveActionOutputV2 = z.object({
  type: z.literal("DocumentationPageMove"),
  output: SuccessPayload,
});

export const DTODocumentationPageDuplicateActionOutputV2 = z.object({
  type: z.literal("DocumentationPageDuplicate"),
  output: SuccessPayload,
});

export const DTODocumentationPageDeleteActionOutputV2 = z.object({
  type: z.literal("DocumentationPageDelete"),
  output: SuccessPayload,
});

export const DTODocumentationPageRestoreActionOutput = z.object({
  type: z.literal("DocumentationPageRestore"),
  output: SuccessPayload,
});

export const DTODocumentationGroupRestoreActionOutput = z.object({
  type: z.literal("DocumentationGroupRestore"),
  output: SuccessPayload,
});

export const DTODocumentationPageApprovalStateChangeActionOutput = z.object({
  type: z.literal("DocumentationPageApprovalStateChange"),
  output: SuccessPayload,
});

export type DTODocumentationPageCreateActionOutputV2 = z.infer<typeof DTODocumentationPageCreateActionOutputV2>;
export type DTODocumentationPageUpdateActionOutputV2 = z.infer<typeof DTODocumentationPageUpdateActionOutputV2>;
export type DTODocumentationPageUpdateDocumentActionOutputV2 = z.infer<
  typeof DTODocumentationPageUpdateDocumentActionOutputV2
>;
export type DTODocumentationPageMoveActionOutputV2 = z.infer<typeof DTODocumentationPageMoveActionOutputV2>;
export type DTODocumentationPageDuplicateActionOutputV2 = z.infer<typeof DTODocumentationPageDuplicateActionOutputV2>;
export type DTODocumentationPageDeleteActionOutputV2 = z.infer<typeof DTODocumentationPageDeleteActionOutputV2>;
export type DTODocumentationPageRestoreActionOutput = z.infer<typeof DTODocumentationPageRestoreActionOutput>;
export type DTODocumentationGroupRestoreActionOutput = z.infer<typeof DTODocumentationGroupRestoreActionOutput>;
export type DTODocumentationPageApprovalStateChangeActionOutput = z.infer<
  typeof DTODocumentationPageApprovalStateChangeActionOutput
>;

// Write
//

export const DTODocumentationPageCreateActionInputV2 = z.object({
  type: z.literal("DocumentationPageCreate"),
  input: DTOCreateDocumentationPageInputV2,
});

export const DTODocumentationPageUpdateActionInputV2 = z.object({
  type: z.literal("DocumentationPageUpdate"),
  input: DTOUpdateDocumentationPageInputV2,
});

export const DTODocumentationPageUpdateDocumentActionInputV2 = z.object({
  type: z.literal("DocumentationPageUpdateDocument"),
  input: DTOUpdateDocumentationPageDocumentInputV2,
});

export const DTODocumentationPageMoveActionInputV2 = z.object({
  type: z.literal("DocumentationPageMove"),
  input: DTOMoveDocumentationPageInputV2,
});

export const DTODocumentationPageDuplicateActionInputV2 = z.object({
  type: z.literal("DocumentationPageDuplicate"),
  input: DTODuplicateDocumentationPageInputV2,
});

export const DTODocumentationPageDeleteActionInputV2 = z.object({
  type: z.literal("DocumentationPageDelete"),
  input: DTODeleteDocumentationPageInputV2,
});

export const DTODocumentationPageRestoreActionInput = z.object({
  type: z.literal("DocumentationPageRestore"),
  input: DTORestoreDocumentationPageInput,
});

export const DTODocumentationGroupRestoreActionInput = z.object({
  type: z.literal("DocumentationGroupRestore"),
  input: DTORestoreDocumentationGroupInput,
});

export const DTODocumentationPageApprovalStateChangeActionInput = z.object({
  type: z.literal("DocumentationPageApprovalStateChange"),
  input: DTODocumentationPageApprovalStateChangeInput,
});

export type DTODocumentationPageCreateActionInputV2 = z.infer<typeof DTODocumentationPageCreateActionInputV2>;
export type DTODocumentationPageUpdateActionInputV2 = z.infer<typeof DTODocumentationPageUpdateActionInputV2>;
export type DTODocumentationPageUpdateDocumentActionInputV2 = z.infer<
  typeof DTODocumentationPageUpdateDocumentActionInputV2
>;
export type DTODocumentationPageMoveActionInputV2 = z.infer<typeof DTODocumentationPageMoveActionInputV2>;
export type DTODocumentationPageDuplicateActionInputV2 = z.infer<typeof DTODocumentationPageDuplicateActionInputV2>;
export type DTODocumentationPageDeleteActionInputV2 = z.infer<typeof DTODocumentationPageDeleteActionInputV2>;
export type DTODocumentationPageRestoreActionInput = z.infer<typeof DTODocumentationPageRestoreActionInput>;
export type DTODocumentationGroupRestoreActionInput = z.infer<typeof DTODocumentationGroupRestoreActionInput>;
